import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { FormProps } from '@forms/types';
import { useAddAndScheduleTask } from '@services/jobs/tasks/addAndSchedule';
import { AddAndScheduleTaskResp } from '@services/jobs/tasks/types';
import { AddTaskScheduleFormProps, AddTaskScheduleFormValues } from './types';
import { defaultValues, formSchema } from './constants';
import { getSelectedDays, isExistingTask, toDayKey } from './helpers';

export const useAddTaskScheduleForm = ({
  jobId,
  stageId,
  task,
  successHandler,
}: FormProps<AddTaskScheduleFormProps, AddAndScheduleTaskResp>) => {
  const form = useForm<AddTaskScheduleFormValues>({
    resolver: zodResolver(formSchema),
    defaultValues,
  });

  const { mutate, isLoading } = useAddAndScheduleTask((resp) => {
    if (resp.success) successHandler(resp);
  });

  const submit =
    (send: boolean) =>
    ({ days, foremanId, defaultCrew, defaultEquipment }: AddTaskScheduleFormValues) => {
      if (!task) return;
      const existing = isExistingTask(task.id);
      mutate({
        jobId,
        stageId,
        taskName: existing ? task.name : task.id,
        stageName: existing ? undefined : task.stageName,
        originalTaskId: existing ? task.id : undefined,
        foremanId: foremanId || null,
        status: send && foremanId ? '' : 'draft',
        defaultCrew: Boolean(foremanId && defaultCrew),
        defaultEquipment: Boolean(foremanId && defaultEquipment),
        dates: getSelectedDays(days).map(toDayKey),
      });
    };

  return {
    form,
    onSaveDraft: form.handleSubmit(submit(false)),
    onSend: form.handleSubmit(submit(true)),
    locked: isLoading,
  };
};
